/**
* @author Camilo Ramirez
* @Copyright (c) Infotrack. All rights reserved.
*/

const mensajes = {
    'sidebar.Infotrack.SmartStock': 'Infotrack.SmartStock',
    'sidebar.tipoconteoauditoria': 'Tipo Conteo Auditoria',
    'tipoConteoAuditoria.agregarTipoConteoAuditoria': 'Crear Tipo Conteo Auditoria',
    'tipoConteoAuditoria.modificarTipoConteoAuditoria': 'Editar Tipo Conteo Auditoria',
    'tipoConteoAuditoria.idTipoConteo': 'Id Tipo Conteo',
    'tipoConteoAuditoria.descripcionTipoConteo': 'Descripcion Tipo Conteo',
    'tipoConteoAuditoria.idEmpresa': 'Id Empresa',
    'tipoConteoAuditoria.idAgencia': 'Id Agencia',
    'tipoConteoAuditoria.estado': 'Estado',
    'tipoConteoAuditoria.verTipoConteoAuditoria': 'Ver Tipo Conteo Auditoria',
    'tipoConteoAuditoria.CampoTipoConteoDescripcion.Nombre': 'Tipo conteo',
    'tipoConteoAuditoria.BotonCompararConteos.Nombre': 'Comparar conteos',
    };
export default mensajes;

